export default {
    navbar: {
        dashboard: '首页',
        logOut: '退出登录',
        changePassword: '修改密码',
        // profile: '个人中心',
        // theme: '换肤',
        // size: '布局大小'
    },

    route: {
        home: '首页',
        changePassword: '修改密码',

        pms: '商品管理',
        product: '商品列表',
        addProduct: '添加商品',
        updateProduct: '修改商品',
        productRecycle: '商品回收站',
        productComment: '商品评价',
        productCate: '商品分类',
        addProductCate: '添加商品分类',
        updateProductCate: '修改商品分类',
        productAttr: '商品类型',
        productAttrList: '商品属性列表',
        addProductAttr: '添加商品属性',
        updateProductAttr: '修改商品属性',
        brand: '品牌管理',
        addBrand: '添加品牌',
        updateBrand: '编辑品牌',
        exchangeRate: '汇率设置',

        crm: '会员管理',
        member: '会员列表',
        memberDetail: '查看会员',
        updateMember: '编辑会员',
        memberLevel: '会员等级',

        sms: '营销',
        couponList: '优惠券列表',
        addCoupon: '添加优惠券',
        updateCoupon: '修改优惠券',
        couponHistory: '优惠券领取详情',
        advertiseList: '广告列表',
        addAdvertise: '添加广告',
        updateAdvertise: '编辑广告',

        oms: '订单管理',
        order: '订单列表',
        orderDetail: '订单详情',
        deliverOrderList: '发货列表',
        orderSetting: '订单设置',
        returnApply: '退货申请处理',
        returnReason: '退货原因设置',
        returnApplyDetail: '退货原因详情',

        mms: '商家管理',
        shop: '商家列表',
        addShop: '新增商家',
        updateShop: '修改商家',
        withdraw: '提现申请',
        clearing: '店铺结算',

        cms: '资讯文章',
        article: '文章列表',
        addArticle: '新增文章',

        sys: '系统配置',
        params: '系统参数',
        permission: '权限管理',
        employeesList: '员工列表',
        roleList: '角色列表',
        allocMenu: '分配菜单',
        allocResource: '分配资源',
        menuList: '菜单列表',
        addMenu: '添加菜单',
        updateMenu: '修改菜单',
        resourceList: '资源列表',
        resourceCategory: '资源分类',

        vms: '视频',
        video: '视频列表',
        videoLivePlan: '直播计划列表',
        addVideoLivePlan: '添加直播计划',
        updateVideoLivePlan: '编辑直播计划',

        tagsView: {
            refresh: '刷新',
            close: '关闭',
            closeOthers: '关闭其它',
            closeAll: '关闭所有'
        }

    },


    //----------------------------------------------------hungkin国际化----------------------------------------------------------------------
    base:{
        add:'添加',
        delete:'删除',
        edit:'编辑',
        batchOperate:'批量操作',
        prompt:'提示',
        define:'确定',
        cancel:'取消',
        wideDefine:'确 定',
        wideCancel:'取 消',
        search:{
            searchTitle: '筛选搜索',
            searchBtn: '查询搜索',
            resetBtn: '重置',
        },
        isBatchText:'是否要进行该批量操作？',
        isEditText:'是否要进行修改？',
        editSuccess:'修改成功',
        noSkuInfo:'暂无sku信息',
        selectOperatesPrdText:'请选择要操作的商品',
        selectOperatesType:'请选择操作类型',
    },

    product: {
        list: {
            searchTitle: '筛选搜索',
            searchBtn: '查询搜索',
            resetBtn: '重置',
            keyword: '输入搜索',
            productCode: '商品货号',
            categories: '商品分类',
            selectCategories: '请选择商品分类',
            productBrand: '商品品牌',
            selectBrand: '请选择品牌',
            shelfStatus: '上架状态',
            approvalStatus: '审核状态',
            price: '价格',
            itemNo: '货号',
            putOnTheShelf: '上架',
            newProduct: '新品',
            recommend: '推荐',
            table: {
                datasheets: '数据列表',
                serialNumber: '编号',
                productPic: '商品图片',
                brand: '品牌',
                productName: '商品名称',
                shopName: '商家名称',
                priceItemNumber: '价格/货号',
                tag: '标签',
                skuInventory: 'SKU库存',
                sales: '销量',
                createTime: '创建时间',
                approvalStatus: '审核状态',
                operate: '操作',
            },
            editPrdInfo: '编辑货品信息',
            searchText: '按sku编号搜索',
            skuNumber: 'SKU编号',
            sellingPrice: '销售价格',
            commodityStocks: '商品库存',
            inventoryWarning: '库存预警值',
            lengthCm: '长cm',
            widthCm: '宽cm',
            heightCm: '高cm',
            volume: '体积cm³',
            weight: '重量（克）',
            sort: '排序',
            batchOperates:{
                publishOn:'商品上架',
                publishOff:'商品下架',
                recommendOn:'设为推荐',
                recommendOff:'取消推荐',
                newOn:'设为新品',
                newOff:'取消新品',
                verifyOn:'审核通过',
                verifyOff:'取消审核',
            },
            publishStatusOptions:{
                publishOn:'上架',
                publishOff:'下架',
                verifyOn:'审核通过',
                verifyOff:'未审核',
            }
        }
    },

}



// WEBPACK FOOTER //
// ./src/lang/zh.js